<template>
  <div class="login-wrapper">
    
    <div class="custom-login-header elevation-2">
      <div class="header-content px-4 d-flex justify-space-between align-center">
        <v-img src="https://mvexpress.mx/images/logosapp/logomv2.png" max-width="140" contain></v-img>

        <div class="d-flex align-center gap-1">
          <v-btn icon size="small" variant="text" color="blue-darken-4" href="https://www.facebook.com/share/12GUzZZtKYD/" target="_blank">
            <v-icon size="24">mdi-facebook</v-icon>
          </v-btn>

          <v-btn icon size="small" variant="text" color="green" href="https://wa.link/plk405" target="_blank">
            <v-icon size="24">mdi-whatsapp</v-icon>
          </v-btn>

          <v-btn icon size="small" variant="text" color="blue-darken-2" href="https://mx.linkedin.com/company/grupo-mv-distribuciones" target="_blank">
            <v-icon size="24">mdi-linkedin</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="main-content">
      <v-container>
        <v-row align="center" justify="center" no-gutters>
  <v-col cols="12" md="6" class="d-flex justify-center mb-4">
    <v-carousel cycle hide-delimiters :interval="3000" height="250" class="carousel-wrapper rounded-xl">
        <v-carousel-item v-for="(image, i) in images" :key="i">
            <v-img :src="image"  height="100%"></v-img>
        </v-carousel-item>
    </v-carousel>
</v-col>
          <v-col cols="12" md="4">
            <v-card class="login-card pa-4" elevation="6" rounded="xl">
              <div class="text-center mb-4">
                 <h2 class="text-h5 font-weight-bold text-blue-darken-4">Bienvenido</h2>
                 <p class="text-caption text-grey">Inicia sesión para continuar</p>
              </div>

              <v-form ref="form" v-model="valid">
                <v-text-field 
                    label="Correo Electrónico" 
                    v-model="email" 
                    :rules="[rules.required, rules.email]"
                    prepend-inner-icon="mdi-email-outline" 
                    variant="outlined" 
                    density="comfortable"
                    color="blue-darken-3"
                    class="mb-2"
                ></v-text-field>

                <v-text-field 
                    :type="showPassword ? 'text' : 'password'" 
                    label="Contraseña" 
                    v-model="password"
                    :rules="[rules.required]" 
                    prepend-inner-icon="mdi-lock-outline"
                    :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append-inner="showPassword = !showPassword" 
                    variant="outlined" 
                    density="comfortable"
                    color="blue-darken-3"
                ></v-text-field>

                <div class="d-flex justify-space-between align-center mb-4 flex-wrap">
                    <v-checkbox v-model="rememberEmail" label="Recordar" density="compact" hide-details color="blue"></v-checkbox>
                    <v-btn variant="text" size="small" color="blue-darken-3" class="text-capitalize" @click="recoverPassword">
                        ¿Olvidaste contraseña?
                    </v-btn>
                </div>

                <v-btn block color="blue-darken-4" size="large" rounded="lg" :disabled="!valid" @click="login" elevation="2" class="mb-3 font-weight-bold">
                  Ingresar
                </v-btn>
                
                <v-btn block variant="outlined" color="blue-darken-4" size="large" rounded="lg" @click="registrologin" class="font-weight-bold">
                  Crear cuenta
                </v-btn>
              </v-form>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </div>
  </div>
</template>
<style scoped>
/* El secreto está aquí */
.custom-login-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
  /* El padding-top hace que el blanco suba a la barra de estado */
  padding-top: env(safe-area-inset-top, 30px);
  /* Pero la altura total se ajusta para que el contenido baje */
  height: calc(64px + env(safe-area-inset-top, 30px));
}

.main-content {
  background-image: url("https://mvexpress.mx/images/publicidad/patronazul.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  /* El padding-top lo calcula v-main automáticamente */
}

.login-card {
  background-color: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
}
</style>

<script>
import Swal from "sweetalert2";
import { Preferences } from "@capacitor/preferences";
import { requestWebPushPermission } from "././../../firebase";
import axios from "axios";
import { useUserStore } from "../stores/userStore";


export default {
  data() {
    return {
      
    

      images: [
        "https://scontent.ftgz3-1.fna.fbcdn.net/v/t39.30808-6/576568890_1248891397261993_4507525136085772847_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=86c6b0&_nc_eui2=AeHaFrRXMj1g4CDfMbNKEctVUbyYL0nNbUdRvJgvSc1tR4-Y5awqN-ld_7D-2OstjTpgX3-eR0EGJp_zzrk2U-gV&_nc_ohc=5Zg8m4Y542UQ7kNvwGY_zfF&_nc_oc=Adl-UOVoR_RbJ0iT4gW_uuYZWJlzqjDHuFgHbc1hxcRvJ7Q61pLGGwPGoxKhCOdBb8Y&_nc_zt=23&_nc_ht=scontent.ftgz3-1.fna&_nc_gid=qBdNufKtpe_kSUOep9FL7Q&oh=00_Afk35f8S1GfVklRWSVbJ-eKUpMwzqtHmO-ZUARDdV2NTwA&oe=694F4D76",
        "https://grupomv.mx/images/2025/login2.jpg",
        "https://grupomv.mx/images/2025/login3.jpg",
        "https://grupomv.mx/images/2025/login4.jpg",
        "https://grupomv.mx/images/2025/login5.jpg",
        "https://grupomv.mx/images/2025/login6.png",
        "https://grupomv.mx/images/2025/login7.jpg",
        "https://grupomv.mx/images/2025/login8.jpg",
        "https://grupomv.mx/images/2025/login9.jpg",
        "https://grupomv.mx/images/2025/login10.jpg",
      ],
      email: "",
      password: "",
      valid: false,
      showPassword: false,
      rememberEmail: false,
      rules: {
        required: (value) => !!value || "Este campo es obligatorio.",
        email: (value) => /.+@.+\..+/.test(value) || "Ingrese un correo válido.",
      },
    };
  },
  async mounted() {
 
  },
  async created() {
    // Cargar correo guardado desde Capacitor Storage al iniciar
const { value } = await Preferences.get({ key: "remember_email" });
    if (value) {
      this.email = value;
      this.rememberEmail = true;
    }
  },

  methods: {
    // Registrar token FCM
    // Registrar token FCM
    async registrarTokenFCM() {
      try {
        const fcmToken = await requestWebPushPermission();
        console.log("✅ Token FCM obtenido:", fcmToken);

        // Guardar localmente
        await this.guardarTokenFCMLocal(fcmToken);

        const userStore = useUserStore();
        const jwtToken = userStore.token;

        if (!jwtToken) {
          console.error("❌ No hay token JWT válido");
          return;
        }

        const headers = { Authorization: `Bearer ${jwtToken}` };
        console.log("📤 Headers que se enviarán:", headers);

        await axios.post(
          "https://mvexpress.mx/api/api/notificaciones/guardar-token",
          { token: fcmToken, dispositivo: "web", grupo: "general" },
          { headers }
        );

        console.log("✅ Token FCM enviado al backend correctamente");
      } catch (err) {
        console.error("❌ Error registrando token FCM:", err);
      }
    },

    // Guardar token FCM en Storage
    async guardarTokenFCMLocal(token) {
      await Preferences.set({ key: "fcm_token", value: token });
      console.log("✅ Token FCM guardado localmente:", token);
    },


    validateForm() {
      // Validamos email y password usando reglas
      const emailValid = this.rules.email(this.email) === true;
      const passwordValid = this.rules.required(this.password) === true;
      this.valid = emailValid && passwordValid;
    },


    

    registrologin() {
      this.$router.push({ path: "/registro" });
    },
    // 🔹 Método para solicitar restablecimiento de contraseña
    // 🔹 Ventana para ingresar código + nueva contraseña

async confirmResetPassword() {
  const result = await Swal.fire({
    title: '<span style="color: #1945a3; font-weight: 700; font-size: 1.4rem;">Restablecer contraseña</span>',
    allowOutsideClick: false,
    html: `
      <div style="text-align:left; font-family: 'Roboto', sans-serif; padding: 0 10px;">
        <p style="color: #666; font-size: 0.95rem; text-align: center; margin-bottom: 20px;">
          Ingresa el código que enviamos a tu correo y crea una nueva contraseña segura.
        </p>

        <div style="margin-bottom: 16px;">
          <label style="display:block; font-weight:600; color: #444; font-size: 0.9rem; margin-bottom: 6px;">Código de verificación</label>
          <input id="swal-code" type="number" class="swal2-input" placeholder="Ej: 123456" 
            style="margin:0; width:100%; font-size: 1rem; height: 2.8em; border-radius: 8px; border: 1px solid #ccc;">
        </div>

        <div style="margin-bottom: 16px;">
          <label style="display:block; font-weight:600; color: #444; font-size: 0.9rem; margin-bottom: 6px;">Nueva contraseña</label>
          <input id="swal-pass1" type="password" class="swal2-input" placeholder="********" 
            style="margin:0; width:100%; font-size: 1rem; height: 2.8em; border-radius: 8px; border: 1px solid #ccc;">
        </div>

        <div style="margin-bottom: 20px;">
          <label style="display:block; font-weight:600; color: #444; font-size: 0.9rem; margin-bottom: 6px;">Confirmar contraseña</label>
          <input id="swal-pass2" type="password" class="swal2-input" placeholder="********" 
            style="margin:0; width:100%; font-size: 1rem; height: 2.8em; border-radius: 8px; border: 1px solid #ccc;">
        </div>

        <div style="text-align: center; font-size: 0.85rem; color: #888; border-top: 1px solid #eee; padding-top: 15px;">
          ¿Necesitas ayuda? <a href="mailto:soporte@mvexpress.mx" style="color:#1945a3; text-decoration:none; font-weight:600;">Contactar soporte</a>
        </div>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: "Guardar contraseña",
    cancelButtonText: "Cancelar",
    showLoaderOnConfirm: true,

    // 🎨 ESTILOS
    background: "#FFFFFF",
    confirmButtonColor: "#1945a3", // Azul corporativo
    cancelButtonColor: "#d33",
    customClass: {
      confirmButton: "swal-btn-white-text",
      cancelButton: "swal-btn-white-text",
    },

    preConfirm: async () => {
      const codigo = document.getElementById("swal-code").value;
      const pass1 = document.getElementById("swal-pass1").value;
      const pass2 = document.getElementById("swal-pass2").value;

      if (!codigo) {
        Swal.showValidationMessage("Debes ingresar el código");
        return false;
      }

      if (!/^\d+$/.test(codigo)) {
        Swal.showValidationMessage("El código debe contener solo números");
        return false;
      }

      if (!pass1) {
        Swal.showValidationMessage("Debes ingresar una contraseña");
        return false;
      }

      if (pass1 !== pass2) {
        Swal.showValidationMessage("Las contraseñas no coinciden");
        return false;
      }

      try {
        await axios.post(
          "https://mvexpress.mx/api/auth/auth-resetPass",
          {
            email: this.email,
            codigo,
            nuevaPassword: pass1,
          }
        );

        return true;
      } catch (err) {
        Swal.showValidationMessage(
          err.response?.data?.message || "Código incorrecto"
        );
        return false;
      }
    },
  });

  if (result.isConfirmed) {
    await Swal.fire({
      icon: "success",
      title: "Contraseña actualizada",
      text: "Tu contraseña fue restablecida correctamente.",
      background: "#FFFFFF",
      color: "#000000",
      confirmButtonColor: "#1976D2",
      customClass: {
        confirmButton: "swal-btn-white-text",
      },
    });
  }
},


  async recoverPassword() {
  try {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;

    const { value: email } = await Swal.fire({
      title: "Restablecer contraseña",
      html: `
        <div style="text-align:left; font-family: 'Roboto', sans-serif; padding: 0 10px;">
          <label style="display:block; font-weight:600; color: #444; font-size: 0.9rem; margin-bottom: 6px;">Correo electrónico</label>
          <input id="swal-input-email" class="swal2-input" placeholder="correo@ejemplo.com" type="email" style="margin: 0 0 15px 0; width: 100%;">
          
          <label style="display:block; font-weight:600; color: #444; font-size: 0.9rem; margin-bottom: 6px;">Seguridad: ¿Cuánto es ${num1} + ${num2}?</label>
          <input id="swal-input-captcha" type="number" class="swal2-input" placeholder="Respuesta" style="margin: 0; width: 100%;">
        </div>
      `,
      confirmButtonText: "Enviar código",
      cancelButtonText: "Cancelar",
      showCancelButton: true,

      // 🎨 COLORES
      confirmButtonColor: "#1976D2", // azul
      cancelButtonColor: "#F44336",  // rojo
      customClass: {
        confirmButton: "swal-btn-white-text",
        cancelButton: "swal-btn-white-text",
      },

      preConfirm: () => {
        const emailVal = document.getElementById('swal-input-email').value;
        const captchaVal = document.getElementById('swal-input-captcha').value;
        
        if (!emailVal) return Swal.showValidationMessage("Debes ingresar un correo");
        if (!/.+@.+\..+/.test(emailVal)) return Swal.showValidationMessage("Correo inválido");
        if (!captchaVal) return Swal.showValidationMessage("Resuelve la operación");
        if (parseInt(captchaVal) !== (num1 + num2)) return Swal.showValidationMessage("Resultado incorrecto");
        
        return emailVal;
      },
    });

    if (!email) return;

    this.email = email;

    await axios.post(
      "https://mvexpress.mx/api/auth/auth-request-resetPassword",
      { email }
    );

    await Swal.fire({
      icon: "success",
      title: "Código enviado",
      text: "Revisa tu correo para continuar.",
      confirmButtonColor: "#1976D2",
      customClass: {
        confirmButton: "swal-btn-white-text",
      },
    });

    await this.confirmResetPassword();

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: err.response?.data?.message || "No se pudo procesar la solicitud.",
      confirmButtonColor: "#F44336",
      customClass: {
        confirmButton: "swal-btn-white-text",
      },
    });
  }
},

async login() {
  try {
    const userStore = useUserStore();
    await userStore.login(this.email, this.password);
    console.log("Bearer Token:", userStore.token);

    // Guardar correo si está marcado
    if (this.rememberEmail) {
      await Preferences.set({
        key: "remember_email",
        value: this.email,
      });
    } else {
      await Preferences.remove({ key: "remember_email" });
    }

    this.$router.push("/user-info");
  } catch (err) {
Swal.fire({
  icon: "info",
  title: "Credenciales incorrectas",
  text: "El usuario o la contraseña no son válidos. Intenta nuevamente.",
  confirmButtonText: "Aceptar",
  confirmButtonColor: "#fffff",
  buttonsStyling: true,
});

  }
}



  },
};
</script>
